export const localesZh = {
    'zh-TW': {
        nav_home: "首頁", nav_explore: "探索", nav_media: "影音", nav_references: "參考", nav_chat: "線上客服",
        search_placeholder: "搜尋...",
        search_clear_aria: "清除搜尋內容",
        mobile_search_title: "搜尋",
        lang_btn_aria: "切換語言",
        theme_btn_aria: "切換明暗主題",
        search_filter_all: "全部", search_filter_articles: "文章", search_filter_video: "影片", search_filter_audio: "音訊",
        search_recent: "最近搜尋", search_clear_all: "清除全部", search_trending: "熱門搜尋", search_featured: "精選推薦",
        search_no_results: "查無相符結果", search_history: "搜尋歷史",
        search_trending_title: "熱門主題", search_all_results_for: "查看所有搜尋結果：",
        home_badge: "傾聽心靈聲音",
        home_title: "順化的人間奇蹟",
        card_health: "健康", card_work: "工作事業", card_love: "愛情緣分", card_family: "家庭親情",
        card_spirit: "心靈昇華", card_science: "探索科學", card_culture: "傳統文化",
        explore_now: "立即探索 →", read_mins: "分鐘閱讀",
        card_finance: "財富", card_reincarnation: "穿越 / 輪迴",
        card_hue: "順化", prompt_hue: "順化的人間奇蹟",
        card_danang: "峴港", prompt_danang: "峴港的人間奇蹟",
        card_binhdinh: "平定", prompt_binhdinh: "平定的人間奇蹟",
        card_vungtau: "頭頓", prompt_vungtau: "頭頓的人間奇蹟",
        card_bentre: "檳椥", prompt_bentre: "檳椥的人間奇蹟",
        story_answer_btn: "答案：為什麼有人類",
        story_close_aria: "關閉故事",
        story_next_aria: "下一頁",
        story_prev_aria: "上一頁",
        quiz_step_1: "步驟 1/2", quiz_step_2: "步驟 2/2",
        quiz_continue: "繼續", quiz_find_answer: "尋找答案", quiz_back: "重新選擇",
        quiz_your_choice: "你的選擇", quiz_close_aria: "關閉", quiz_hint: "請選擇一個答案以繼續",
        carousel_prev_aria: "上一個主題", carousel_next_aria: "下一個主題",
        master_banner_author: "法輪大法創始人發表文章：",
        banner_title_1: "為什麼會有人類",
        banner_title_2: "為什麼要<br>救度眾生",
        banner_title_3: "為什麼人類社會<br>是迷？",
        spotlight_title: "精選文章",
        "sec_nhung-cau-chuyen-than-ky": "神蹟故事",
        "sec_gioi-thieu-phap-luan-dai-phap": "認識法輪大法",
        "sec_vung-dat-con-nguoi": "土地與人物",
        "sec_chan-tuong-cuoc-buc-hai": "迫害真相",
        "sec_van-hoa": "神傳文化",
        "sec_video": "影音精選",
        "sec_su-kien": "時事與動態",
        view_more: "查看更多", read_more: "閱讀全文", share_action: "分享",
        network_title: "參考鏈接",
        desc_mrsecret: "解開宇宙與人類的奧秘",
        desc_tantheky: "真實、人性化的時事新聞",
        desc_ganjing: "乾淨且安全的影音平台",
        desc_zhengjian: "傳統文化與生命科學",
        desc_minghui: "法輪大法全球訊息",
        desc_falundafa: "法輪大法官方資訊網站",
        desc_shenyun: "復興五千年神傳文明",
        desc_newcentury: "啟迪心靈的獨立電影製片廠",
        breadcrumb_home: "首頁", breadcrumb_explore: "探索", breadcrumb_category: "專題",
        back: "返回", all_articles: "所有文章", articles_unit: "篇文章",
        loading_more_articles: "正在載入更多文章...", load_more_btn: "載入更多文章",
        all_articles_loaded: "已顯示所有文章",
        no_articles_in_cat: "此專題尚無文章",
        no_articles_hint: "請選擇其他專題或重置篩選條件以探索豐富文章。",
        view_all_articles_btn: "查看所有文章",
        story_posted_by: "由 dieukydieu.tv 發布 • 深度探索",
        media_title: "影音庫", media_filter_all: "全部", media_filter_video: "影片", media_filter_audio: "音訊",
        livechat_header_title: "dieukydieu.tv 客服支援", livechat_online_status: "● 線上",
        livechat_welcome_msg: "您好！dieukydieu.tv 隨時樂意傾聽並與您分享生命的奇蹟，解答關於法輪大法、打坐冥想或生命科學的疑問。今天您想了解什麼呢？",
        livechat_sug_1: "什麼是法輪大法？",
        livechat_sug_2: "五套功法學習指南",
        livechat_sug_3: "祛病健身奇蹟是真的嗎？",
        livechat_input_placeholder: "輸入您的提問或想法...",
        livechat_send_aria: "發送訊息", livechat_close_aria: "關閉聊天", chat_bubble_aria: "開啟即時客服支援",
        share_modal_title: "分享文章", share_copy_link_btn: "複製鏈接",
        share_qr_instruction: "或用手機掃描QR碼", share_copy_action: "複製",
        toast_copied_text: "已複製鏈接到剪貼板！",
        player_playing_from: "正在播放自", player_source_title: "寧靜精選",
        player_default_title: "曲目名稱", player_default_artist: "藝術家",
        player_tab_track: "歌曲", player_tab_queue: "待播清單", player_tab_lyrics: "歌詞",
        player_queue_heading: "播放隊列", player_shuffle_btn: "隨機重排",
        player_lyrics_heading: "歌詞", player_lyrics_updating: "歌詞更新中...",
        player_options_title: "歌曲選項", player_sleep_timer: "定時關閉",
        player_timer_off: "已關閉", player_timer_min_suffix: "分鐘",
        player_speed: "播放速度", player_speed_normal: "1.0x (正常)", player_speed_normal_word: "正常",
        player_share: "分享歌曲", player_share_sub: "複製鏈接或分享給好友",
        player_stop: "退出播放器",
        player_timer_15m: "15分鐘", player_timer_30m: "30分鐘", player_timer_45m: "45分鐘", player_timer_60m: "60分鐘",
        player_timer_track_end: "播完本首", player_timer_cancel_btn: "取消定時",
        player_min_aria: "縮小至迷你播放器", player_more_aria: "更多選項", player_fav_aria: "收藏",
        player_shuffle_aria: "隨機播放", player_prev_aria: "上一首", player_play_aria: "播放或暫停",
        player_next_aria: "下一首", player_repeat_aria: "循環播放", player_close_aria: "關閉音樂播放器",
        toast_unliked: "已取消喜歡",
        toast_liked: "已喜歡文章！❤️",
        toast_link_copied: "鏈接已複製到剪貼板！",
        toast_timer_stopped_end: "定時器：曲目結束已停止播放",
        toast_shuffle_on: "已開啟隨機播放",
        toast_shuffle_off: "已關閉隨機播放",
        toast_repeat_off: "已關閉循環",
        toast_repeat_all: "列表循環",
        toast_repeat_one: "單曲循環",
        toast_fav_removed: "已移出喜愛列表",
        toast_fav_added: "已添加到喜愛列表！❤️",
        toast_track_info_copied: "曲目信息已複製！",
        toast_shuffle_play: "已隨機播放！",
        toast_speed_prefix: "播放速度：",
        toast_muted: "已靜音",
        toast_unmuted: "已取消靜音",
        toast_timer_off: "已關閉定時器",
        toast_timer_end_song: "當前曲目播放完畢後將自動停止",
        toast_timer_after_prefix: "已設置定時於 ",
        toast_timer_stopped: "定時器：已停止播放音樂",
        btt_aria: "回到頂部",
        media_heading_full: "影音與多媒體庫",
        media_works_unit: "部作品",
        media_all_works: "所有影音作品",
        media_cat_music: "音樂", media_cat_video: "影片", media_cat_audio: "音訊", media_cat_gallery: "圖片",
        cinema_footer_note: "由乾淨世界 Gan Jing World 提供播放",
        cinema_open_gjw: "在 GJW 開啟",
        lightbox_download_btn: "下載原圖",
        reader_font_title: "文章字體大小",
        reader_font_reset: "預設",
        reader_font_family_label: "字型：",
        reader_font_serif: "襯線體",
        reader_font_sans: "無襯線",
        story_related_heading: "相關文章",
        story_see_all: "查看全部",
        story_toc_heading: "內容目錄",
        story_bookmark_label: "心靈啟迪",
        master_banner_section_title: "特選作品",
        story_popular_heading: "最多閱讀",
        story_caption_default: "資料圖片"
    },
    'zh-CN': {
        nav_home: "首页", nav_explore: "探索", nav_media: "影音", nav_references: "参考", nav_chat: "在线客服",
        search_placeholder: "搜索...",
        search_clear_aria: "清除搜索内容",
        mobile_search_title: "搜索",
        lang_btn_aria: "切换语言",
        theme_btn_aria: "切换明暗主题",
        search_filter_all: "全部", search_filter_articles: "文章", search_filter_video: "视频", search_filter_audio: "音频",
        search_recent: "最近搜索", search_clear_all: "清除全部", search_trending: "热门搜索", search_featured: "精选推荐",
        search_no_results: "查无匹配结果", search_history: "搜索历史",
        search_trending_title: "热门主题", search_all_results_for: "查看所有搜索结果：",
        home_badge: "倾听心灵声音",
        home_title: "顺化的人间奇迹",
        card_health: "健康", card_work: "工作事业", card_love: "爱情缘分", card_family: "家庭亲情",
        card_spirit: "心灵升华", card_science: "探索科学", card_culture: "传统文化",
        explore_now: "立即探索 →", read_mins: "分钟阅读",
        card_finance: "财富", card_reincarnation: "穿越 / 轮回",
        card_hue: "顺化", prompt_hue: "顺化的人间奇迹",
        card_danang: "岘港", prompt_danang: "岘港的人间奇迹",
        card_binhdinh: "平定", prompt_binhdinh: "平定的人间奇迹",
        card_vungtau: "头顿", prompt_vungtau: "头顿的人间奇迹",
        card_bentre: "槟椥", prompt_bentre: "槟椥的人间奇迹",
        story_answer_btn: "答案：为什么有人类",
        story_close_aria: "关闭故事",
        story_next_aria: "下一页",
        story_prev_aria: "上一页",
        quiz_step_1: "步骤 1/2", quiz_step_2: "步骤 2/2",
        quiz_continue: "继续", quiz_find_answer: "寻找答案", quiz_back: "重新选择",
        quiz_your_choice: "你的选择", quiz_close_aria: "关闭", quiz_hint: "请选择一个答案以继续",
        carousel_prev_aria: "上一个主题", carousel_next_aria: "下一个主题",
        master_banner_author: "法轮大法创始人发表文章：",
        banner_title_1: "为什么会有人类",
        banner_title_2: "为什么要<br>救度众生",
        banner_title_3: "为什么人类社会<br>是迷？",
        spotlight_title: "精选文章",
        "sec_nhung-cau-chuyen-than-ky": "神迹故事",
        "sec_gioi-thieu-phap-luan-dai-phap": "认识法轮大法",
        "sec_vung-dat-con-nguoi": "土地与人物",
        "sec_chan-tuong-cuoc-buc-hai": "迫害真相",
        "sec_van-hoa": "神传文化",
        "sec_video": "影音精选",
        "sec_su-kien": "时事与动态",
        view_more: "查看更多", read_more: "阅读全文", share_action: "分享",
        network_title: "参考链接",
        desc_mrsecret: "解开宇宙与人类的奥秘",
        desc_tantheky: "真实、人性化的时事新闻",
        desc_ganjing: "干净且安全的影音平台",
        desc_zhengjian: "传统文化与生命科学",
        desc_minghui: "法轮大法全球讯息",
        desc_falundafa: "法轮大法官方资讯网站",
        desc_shenyun: "复兴五千年神传文明",
        desc_newcentury: "启迪心灵的独立电影制片厂",
        breadcrumb_home: "首页", breadcrumb_explore: "探索", breadcrumb_category: "专题",
        back: "返回", all_articles: "所有文章", articles_unit: "篇文章",
        loading_more_articles: "正在加载更多文章...", load_more_btn: "加载更多文章",
        all_articles_loaded: "已显示所有文章",
        no_articles_in_cat: "此专题尚无文章",
        no_articles_hint: "请选择其他专题或重置筛选条件以探索丰富文章。",
        view_all_articles_btn: "查看所有文章",
        story_posted_by: "由 dieukydieu.tv 发布 • 深度探索",
        media_title: "影音库", media_filter_all: "全部", media_filter_video: "视频", media_filter_audio: "音频",
        livechat_header_title: "dieukydieu.tv 客服支持", livechat_online_status: "● 在线",
        livechat_welcome_msg: "您好！dieukydieu.tv 随时乐意倾听并与您分享生命的奇迹，解答关于法轮大法、打坐冥想或生命科学的疑问。今天您想了解什么呢？",
        livechat_sug_1: "什么是法轮大法？",
        livechat_sug_2: "五套功法学习指南",
        livechat_sug_3: "祛病健身奇迹是真的吗？",
        livechat_input_placeholder: "输入您的提问或想法...",
        livechat_send_aria: "发送消息", livechat_close_aria: "关闭聊天", chat_bubble_aria: "打开即时客服支持",
        share_modal_title: "分享文章", share_copy_link_btn: "复制链接",
        share_qr_instruction: "或用手机扫描QR码", share_copy_action: "复制",
        toast_copied_text: "已复制链接到剪贴板！",
        player_playing_from: "正在播放自", player_source_title: "宁静精选",
        player_default_title: "曲目名称", player_default_artist: "艺术家",
        player_tab_track: "歌曲", player_tab_queue: "待播清单", player_tab_lyrics: "歌词",
        player_queue_heading: "播放队列", player_shuffle_btn: "随机重排",
        player_lyrics_heading: "歌词", player_lyrics_updating: "歌词更新中...",
        player_options_title: "歌曲选项", player_sleep_timer: "定时关闭",
        player_timer_off: "已关闭", player_timer_min_suffix: "分钟",
        player_speed: "播放速度", player_speed_normal: "1.0x (正常)", player_speed_normal_word: "正常",
        player_share: "分享歌曲", player_share_sub: "复制链接或分享给好友",
        player_stop: "退出播放器",
        player_timer_15m: "15分钟", player_timer_30m: "30分钟", player_timer_45m: "45分钟", player_timer_60m: "60分钟",
        player_timer_track_end: "播完本首", player_timer_cancel_btn: "取消定时",
        player_min_aria: "缩小至迷你播放器", player_more_aria: "更多选项", player_fav_aria: "收藏",
        player_shuffle_aria: "随机播放", player_prev_aria: "上一首", player_play_aria: "播放或暂停",
        player_next_aria: "下一首", player_repeat_aria: "循环播放", player_close_aria: "关闭音乐播放器",
        toast_unliked: "已取消喜欢",
        toast_liked: "已喜欢文章！❤️",
        toast_link_copied: "链接已复制到剪贴板！",
        toast_timer_stopped_end: "定时器：曲目结束已停止播放",
        toast_shuffle_on: "已开启随机播放",
        toast_shuffle_off: "已关闭随机播放",
        toast_repeat_off: "已关闭循环",
        toast_repeat_all: "列表循环",
        toast_repeat_one: "单曲循环",
        toast_fav_removed: "已移出喜爱列表",
        toast_fav_added: "已添加到喜爱列表！❤️",
        toast_track_info_copied: "曲目信息已复制！",
        toast_shuffle_play: "已随机播放！",
        toast_speed_prefix: "播放速度：",
        toast_muted: "已静音",
        toast_unmuted: "已取消静音",
        toast_timer_off: "已关闭定时器",
        toast_timer_end_song: "当前曲目播放完毕后将自动停止",
        toast_timer_after_prefix: "已设置定时于 ",
        toast_timer_stopped: "定时器：已停止播放音乐",
        btt_aria: "回到顶部",
        media_heading_full: "影音与多媒体库",
        media_works_unit: "部作品",
        media_all_works: "所有影音作品",
        media_cat_music: "音乐", media_cat_video: "视频", media_cat_audio: "音频", media_cat_gallery: "图片",
        cinema_footer_note: "由干净世界 Gan Jing World 提供播放",
        cinema_open_gjw: "在 GJW 打开",
        lightbox_download_btn: "下载原图",
        reader_font_title: "文章字体大小",
        reader_font_reset: "默认",
        reader_font_family_label: "字体：",
        reader_font_serif: "衬线体",
        reader_font_sans: "无衬线",
        story_related_heading: "相关文章",
        story_see_all: "查看全部",
        story_toc_heading: "内容目录",
        story_bookmark_label: "心灵启迪",
        master_banner_section_title: "特选作品",
        story_popular_heading: "最多阅读",
        story_caption_default: "资料图片"
    }
};
